import * as React from "react";
import {
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  Box,
  Fade,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import ClosedIconConfirm from "src/assets/images/chat/crossIconConfirm.png";
import { useSelector } from "react-redux";
import useStyle from "./Styles";

interface Props {
  title?: string;
  loader?: boolean;
  img?: any;
  icon?: any;
  text: any;
  btnText: any;
  open: boolean;
  modalClose: () => void;
  actionHandler: any;
  dialogContentBody?: any;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog: React.FC<Props> = ({
  title,
  btnText,
  text,
  open,
  modalClose,
  actionHandler,
  img,
  icon,
  loader,
  dialogContentBody,
}) => {
  const { classes } = useStyle();
  const { connection }: any = useSelector((state: any) => state.connection);

  const removeHandler = async () => {
    await actionHandler();
  };

  const handleClose = () => {
    modalClose();
  };

  return (
    <Dialog
      className={classes.dialog}
      open={open}
      TransitionComponent={Transition}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.iconWrapper}>
          {icon || (
            <img
              src={img || ClosedIconConfirm}
              alt={btnText}
              className={classes.dialogIcon}
            />
          )}
        </Box>
        <Typography component="h1" className={classes.headingStyle}>
          {title || "Are you sure?"}
        </Typography>
        <DialogContentText className={classes.descriptionStyle}>
          {text}
        </DialogContentText>
        {dialogContentBody}
      </DialogContent>
      <DialogActions className={classes.bottomBtnBar}>
        <Button
          className={classes.cancelBtn}
          variant="contained"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          className={classes.saveBtn}
          variant="contained"
          onClick={removeHandler}
          disabled={!connection || loader}
          endIcon={
            loader && <CircularProgress sx={{ color: "white" }} size={15} />
          }
        >
          {btnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CustomDialog.defaultProps = {
  img: undefined,
  icon: undefined,
  loader: false,
};

export default CustomDialog;
